"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Create an end event object with the given name and value. The value is
 * rounded to the nearest integer.
 *
 * @param name - Name of the event
 * @param value - Value of the event
 */
function createEndEvent(name, value) {
    return { [name]: Math.round(value) };
}
exports.default = createEndEvent;
